import React, { FC, useEffect, useState } from 'react';
import TableSimple from 'src/components/TableSimple';
import { TableColumnType, TableRowType } from 'src/types/table';
import translate from '@translate';
import Dialog from 'src/components/Dialog';
import { ProductStockType } from 'src/types/productDetail';

const allColumns: TableColumnType[] = [
    {
        label: 'lot',
        key: 'lot',
    },
    {
        label: 'expirationDate',
        key: 'expirationDate',
        type: 'date',
    },
    {
        label: 'allocated',
        key: 'ALLOCATED_QUANTITY',
        type: 'number-filter',
    },
    {
        label: 'onExpedition',
        key: 'HOLD_QUANTITY',
        type: 'number-filter',
    },
    {
        label: 'available',
        key: 'AVAILABLE_QUANTITY',
        type: 'number-filter',
    },
    {
        label: 'onHoldQuality',
        key: 'QUALITY_HOLD_QUANTITY',
        type: 'number-filter',
    },
    {
        label: 'awaiting',
        key: 'EXPECTED_QUANTITY',
        type: 'number-filter',
    },
    {
        label: 'customsWarehouse',
        key: 'DUTY_QUANTITY',
        type: 'number-filter',
    },
    {
        label: 'all',
        key: 'QUANTITY',
        type: 'number-filter',
    },
];

export interface ProductStockTablePropsType {
    onClose: () => void;
    getProductDetailStockFetch: () => void;
    dataStock: ProductStockType | null;
    loading?: boolean;
    stockRation: number | undefined;
    customsWarehouseEnabled?: boolean;
}

const ProductStockTable: FC<ProductStockTablePropsType> = (props) => {
    const [rows, setRows] = useState<TableRowType[] | null>(null);

    useEffect(() => {
        if (!props.dataStock) {
            props.getProductDetailStockFetch();
        } else {
            if (props.dataStock?.stockItems) {
                setRows(
                    props.dataStock.stockItems.map(
                        (row): TableRowType => {
                            return {
                                id: row.id,
                                lot: row.lot,
                                expirationDate: row.expirationDate,
                                QUANTITY: row.quantity,
                                EXPECTED_QUANTITY: row.referenceN1,
                                QUALITY_HOLD_QUANTITY: row.qualityHoldQuantity,
                                DUTY_QUANTITY: row.referenceN4 ?? 0,
                                ALLOCATED_QUANTITY: row.referenceN2,
                                HOLD_QUANTITY: row.holdQuantity,
                                AVAILABLE_QUANTITY: Math.round(row.referenceN3 * (props.stockRation || 1)),
                            };
                        }
                    )
                );
            }
        }
    }, [props.dataStock]);

    return (
        <Dialog onClose={props.onClose} maxWidth="lg" title={translate('productDetail.titleProductStock')}>
            <TableSimple
                rowIdKey="id"
                rows={rows || []}
                columsLabelPrefix="products.table"
                allColumns={
                    props.customsWarehouseEnabled
                        ? allColumns
                        : allColumns.filter((column) => column.key !== 'DUTY_QUANTITY')
                }
                initSort={{ column: 'id', direction: 'DESC' }}
                loading={props.loading}
                showInModal
            />
        </Dialog>
    );
};

export default ProductStockTable;
